import { Entity, MicroMClient } from "@mcurros2/microm";
import { PersonalTiendasGestionFiltersDef } from "./PersonalTiendasGestionFiltersDef";


export class PersonalTiendasGestionFilters extends Entity<PersonalTiendasGestionFiltersDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new PersonalTiendasGestionFiltersDef(), parentKeys);
        this.Form = import('./PersonalTiendasGestionFiltersForm').then((module) => module.PersonalTiendasGestionFiltersForm);
        this.Title = "Personal Tiendas Filters";
    }
}